<mat-select
  #select
  [id]="matSelectId"
  [(value)]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (selectionChange)="changeValue()"
  (openedChange)="openedChange.emit($event)"
  [class.black-border]="select.focused"
  class="form-control"
  [class.disabled]="disabled"
  [multiple]="multiple"
>
  @if (!multiple) {
  <mat-option>
    <ngx-mat-select-search
      placeholderLabel=""
      noEntriesFoundLabel="Nothing found"
      [hideClearSearchButton]="true"
      [formControl]="filterCtrl"
    ></ngx-mat-select-search>
  </mat-option>
  } @for (option of filteredOptions; track option; let i = $index) {
  <mat-option
    [value]="option.id"
    [class.hidden]="!option.text"
    id="{{ 'option-' + i }}"
  >
    {{ option.text }}
    @if (option.has_any_claims) {
    <span
      matTooltipClass="primary-tooltip"
      matTooltipPosition="above"
      [matTooltip]="'Previous insurance claim recorded'"
    >
      <img src="broken_glass.png" class="broken-glass" style="width: 25px" />
    </span>
    }
  </mat-option>
  }
</mat-select>
